/**
 * Preferences API service
 */

import { apiClient } from './client';
import type {
  DishPreference,
  IngredientPreference,
  UserPreferencesResponse,
  SetDishPreferenceRequest,
  SetIngredientPreferenceRequest,
} from '@/types/api';

export async function getUserPreferences(
  userId: number,
): Promise<UserPreferencesResponse> {
  const response = await apiClient.get<UserPreferencesResponse>(
    `/preferences/users/${userId}`,
  );
  return response.data;
}

export async function getDishPreferences(
  dishId: number,
): Promise<DishPreference[]> {
  const response = await apiClient.get<DishPreference[]>(
    `/preferences/dishes/${dishId}`,
  );
  return response.data;
}

export async function setDishPreference(
  dishId: number,
  data: SetDishPreferenceRequest,
): Promise<DishPreference> {
  const response = await apiClient.put<DishPreference>(
    `/preferences/dishes/${dishId}`,
    data,
  );
  return response.data;
}

export async function removeDishPreference(
  dishId: number,
  userId: number,
): Promise<void> {
  await apiClient.delete(`/preferences/dishes/${dishId}/users/${userId}`);
}

export async function getIngredientPreferences(
  productId: number,
): Promise<IngredientPreference[]> {
  const response = await apiClient.get<IngredientPreference[]>(
    `/preferences/ingredients/${productId}`,
  );
  return response.data;
}

export async function setIngredientPreference(
  productId: number,
  data: SetIngredientPreferenceRequest,
): Promise<IngredientPreference> {
  const response = await apiClient.put<IngredientPreference>(
    `/preferences/ingredients/${productId}`,
    data,
  );
  return response.data;
}

export async function removeIngredientPreference(
  productId: number,
  userId: number,
): Promise<void> {
  await apiClient.delete(`/preferences/ingredients/${productId}/users/${userId}`);
}
